const mainMenus = [
  { header: "Menu Utama" },
  {
    name: "Dashboard",
    title: "Dashboard",
    icon: "dashboard"
  },
  {
    name: "Laporan",
    title: "Laporan",
    icon: "assessment",
    group: "laporan",
    items: [
      {
        name: "LaporanTraining",
        title: "Lap. Training",
        icon: "assignment_turned_in"
      },
      { name: "LaporanClient", title: "Lap. Client", icon: "business" },
      {
        name: "LaporanTrainer",
        title: "Lap. Trainer",
        icon: "directions_run "
      }
    ]
  },
  {
    header: "Menu Inputor",
    role: ["ADMIN", "TRAINING"]
  },
  {
    name: "Materi",
    title: "Materi",
    icon: "chrome_reader_mode"
  },
  {
    name: "Trainer",
    title: "Trainer",
    icon: "directions_run",
    group: "trainers",
    items: [
      {
        name: "TrainerList",
        title: "List Trainer",
        icon: "accessibility"
      },
      { name: "TrainerDivisi", title: "Divisi Trainer", icon: "star" }
    ]
  },
  {
    name: "Training",
    title: "Training",
    icon: "assignment_turned_in",
    group: "trainings",
    items: [
      {
        name: "TrainingList",
        title: "List Training",
        icon: "assignment"
      },
      { name: "TrainingSaya", title: "Training Saya", icon: "assignment_ind" }
    ]
  },
  {
    header: "Menu Admin",
    role: ["ADMIN"]
  },
  {
    name: "Client",
    title: "Client",
    icon: "business",
    group: "clients",
    items: [
      {
        name: "ClientList",
        title: "List Client",
        icon: "location_city"
      },
      { name: "ClientArea", title: "Area Client", icon: "public" }
    ]
  },
  {
    name: "User",
    title: "User",
    icon: "person_outline"
  },
  {
    name: "Sistem",
    title: "Sistem",
    icon: "settings"
  }
];

export default mainMenus;
